module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "calendars-hours-table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.sortedRows), function(row) {
    return _c('tr', {
      key: row.calendar_id,
      staticClass: "calendar-item"
    }, [_c('td', [_vm._v(_vm._s(_vm.calendarName(row.calendar_id)))]), _vm._v(" "), _c('td', [(row.hours) ? _c('input', {
      staticClass: "do-input",
      attrs: {
        "type": "number",
        "step": "0.1"
      },
      domProps: {
        "value": _vm.displayHours(row)
      },
      on: {
        "focus": _vm.selectAll,
        "input": function($event) {
          return _vm.onInput(row.calendar_id, $event.target.value)
        }
      }
    }) : _c('span', [_vm._v("\n          " + _vm._s(_vm.displayHours(row)) + "\n          "), _c('div', {
      staticClass: "do-pill do-pill--yellow calendars-hours-pill"
    }, [_vm._v(_vm._s(_vm.displayHoursSource(row)))])])]), _vm._v(" "), _c('td', [(row.hours) ? _c('button', {
      staticClass: "do-bttn do-bttn--submit",
      class: {
        'do-bttn--submit--loading': _vm.savingRows[row.calendar_id]
      },
      attrs: {
        "disabled": _vm.savingRows[row.calendar_id] || !_vm.isChanged(row)
      },
      on: {
        "click": function($event) {
          return _vm.submitRow(row.calendar_id)
        }
      }
    }, [_vm._v("\n          Gem\n        ")]) : _vm._e()])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-info-box",
    attrs: {
      "role": "note",
      "aria-label": "Forklaring af puljer"
    }
  }, [_c('h3', [_vm._v("Sådan virker differentierede puljer")]), _vm._v(" "), _c('h4', [_vm._v("For klassen")]), _vm._v(" "), _c('p', {
    staticClass: "marg-1-bottom"
  }, [_vm._v("Klassens klokketimer i skoleåret kan afvige fra brikkens standard fx ved\n      fagreduktioner.")]), _vm._v(" "), _c('h4', [_vm._v("For underviseren")]), _vm._v(" "), _c('p', [_vm._v("Underviserens klokketimer i skoleåret kan afvige på to måder:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Der er indtastet en specifik pulje for underviseren.")]), _vm._v(" "), _c('li', [_vm._v("En tilknyttet klasse har en pulje, der afviger fra brikken.")])]), _vm._v(" "), _c('p', [_vm._v("Hvis hverken underviseren eller klassen har en pulje, anvendes brikkens standard.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th'), _vm._v(" "), _c('th', [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Klokketimer i skoleåret")])]), _vm._v(" "), _c('th')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2526293c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormCalendarHours.vue
// module id = 1548
// module chunks = 1